let questionsConfig = {
  shuffle: false,
  questionsList: [
    {
      question: `Elementem zestawu komputerowego jest <img height="100px" src="${require('./img/00.png')}"/>.`,
      correct: true,
    },
    {
      question: `Komputer wyłącza się za pomocą ikony <img height="70px" src="${require('./img/04.png')}"/>.`,
      // correct: true,
    },
    {
      question: `Edytor tekstu Word służy do pisania.`,
      correct: true,
    },
    {
      question: `Aby pisać wielkimi literami należy wcisnąć klawisz <img height="50px" src="${require('./img/01.png')}"/>.`,
      correct: true,
    },
    {
      question: `Program Paint służy do wykonywania obliczeń.`,
      // correct: true,
    },
    {
      question: `Klawisz <img height="50px" src="${require('./img/03.png')}"/> służy do robienia odstępów między znakami i literami.`,
      correct: true,
    },
    {
      question: `Podczas pracy przy komputerze można jeść i pić.`,
      // correct: true,
    },
    {
      question: `Przy komputerze należy siedzieć prosto.`,
      correct: true,
    },
    {
      question: `<img height="50px" src="${require('./img/05.png')}"/> to wskaźnik na ekranie komputera, który się nie porusza.`,
      // correct: true,
    },
    {
      question: `Metoda <i>złap, przesuń, upuść</i> służy do przesuwania elementów na ekranie monitora.`,
      correct: true,
    },
    {
      question: `Program Paint służy głównie do rysowania.`,
      correct: true,
    },
    {
      question: `Pracę wykonaną na komputerze zapisujemy w pliku.`,
      correct: true,
    },
    {
      question: `Folder to mały obrazek który symbolizuje program.`,
      // correct: true,
    },
    {
      question: `Ikona jest to mały obrazek, który symbolizuje program lub folder.`,
      correct: true,
    },
    {
      question: `Narzędzie <img height="60px" src="${require('./img/06.png')}"/> w programie Paint służy do powiększania obrazków.`,
      correct: true,
    },
    {
      question: `Klawisze <img height="50px" src="${require('./img/ctrl.png')}"/> + <img height="50px" src="${require('./img/v.png')}"/> służą do kopiowania.`,
      // correct: true,
    },
    {
      question: `Emotikona to obrazek wyrażający nastrój.`,
      correct: true,
    },
    {
      question: `Klawisz <img height="100px" src="${require('./img/02.png')}"/> służy do przenoszenia kursora do następnej linii.`,
      correct: true,
    },
    {
      question: `<img height="60px" src="${require('./img/07.png')}"/> to narzędzie programu Word.`,
      // correct: true,
    },
    {
      question: `Aby napisać wielkie litery trzeba użyć klawisza <img height="50px" src="${require('./img/99.png')}"/>.`,
      // correct: true,
    },
    {
      question: `Program Kalkulator służy do wykonywania obliczeń.`,
      correct: true,
    },
    {
      question: `Program Word służy wyłącznie do rysowania.`,
      // correct: true,
    },
    {
      question: `Prawy klawisz <img height="50px" src="${require('./img/77.png')}"/> służy do pisania liter: ą, ć, ę, ł, ń, ó, ś, ź, ż.`,
      correct: true,
    },
    {
      question: `Scratch nie służy do nauki programowania.`,
      // correct: true,
    },
    {
      question: `Programowanie w Scratchu polega na układaniu kolorowych bloczków.`,
      correct: true,
    },
  ],
};

export default questionsConfig;
